// extracted by mini-css-extract-plugin
export default {"barLabel":"task-list_barLabel__TWG1p","barLabelOutside":"task-list_barLabelOutside__6glFf"};